// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-checkbox {
  position: relative;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
}

.settings-checkbox input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.settings-checkbox-box {
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-primary);
  border-radius: 4px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, border-color 0.15s;
}

.settings-checkbox input:checked + .settings-checkbox-box {
  background: var(--color-brand);
  border-color: var(--color-brand);
}

.settings-checkbox-tick {
  display: none;
  width: 13.72px;
  height: 9.8px;
  filter: brightness(0) invert(1);
}

.settings-checkbox input:checked + .settings-checkbox-box .settings-checkbox-tick {
  display: block;
}

.settings-checkbox input:disabled + .settings-checkbox-box {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/common/SettingsCheckbox.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".settings-checkbox {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.settings-checkbox input[type='checkbox'] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  pointer-events: none;\n}\n\n.settings-checkbox-box {\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--border-primary);\n  border-radius: 4px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.settings-checkbox input:checked + .settings-checkbox-box {\n  background: var(--color-brand);\n  border-color: var(--color-brand);\n}\n\n.settings-checkbox-tick {\n  display: none;\n  width: 13.72px;\n  height: 9.8px;\n  filter: brightness(0) invert(1);\n}\n\n.settings-checkbox input:checked + .settings-checkbox-box .settings-checkbox-tick {\n  display: block;\n}\n\n.settings-checkbox input:disabled + .settings-checkbox-box {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
